<template>
    <section>
        <a class="whitespace-nowrap text-sm text-neutral-600 sticky bg-white right-0 cursor-pointer" @click="this.openModal">{{ $t('Extend Trial') }}</a>

        <Dialog :title="$t('Update Trial Days')" v-model="dialogVisible">
          <div class="flex items-start px-4 pt-2 pb-4 sm:px-6">
            <p> {{ $t('Enter number of days:') }} </p>
          </div>
          <div class="flex items-center flex-col ml-4 mr-4">
            <input
              type="input"
              class="input"
              v-model="trialDays"
            />
          </div>
          <div class="mt-6 flex justify-center">
              <input type="submit" id="trial-btn" class="
                text-white rounded-lg shadow-sm px-4 py-2 text-sm font-medium
                cursor-pointer
                transition
                duration-150
                ease-in-out
                hover:opacity-90
                mb-2"
                style="background-color: var(--accent-color)"
                @click="submitModal"
                />
          </div>
        </Dialog>
    </section>
</template>

<script>
import Dialog from "../components/dialog";

export default {
    props: ["project-id", "project-update-url"],
    data() {
        return {
            dialogVisible: false,
            trialDays: "",
        };
    },
    components: {
        Dialog,
    },
    methods: {
        openModal() {
            this.dialogVisible = true;
        },
        submitModal() {
          var data = new FormData();
          data.append("project[trial_days]", this.trialDays);
          Rails.ajax({
              url: "/admin/projects/" + this.projectId + "/update_trial_days/",
              type: "PATCH",
              data: data,
              dataType: 'JSON'
          });
        },

    },
};
</script>

<style scoped>
</style>
